import React, { Component } from "react";
import classnames from "classnames";
// import "react-responsive-modal/styles.css";
import { Form, Modal } from "react-bootstrap";
import Alert from "react-s-alert";
//import Row from "react-bootstrap/Row";
// import { Modal } from "react-responsive-modal";
import {
  PopupActionButton,
  PopupInsideButton,
} from "../../buttonReusableComponent/ButtonReusableComponent";
import {
  //TextAreaReusableComponent,
  InputBoxComponent,
  NewInputText,
} from "../../inputReusableComponent/InputBoxComponent";
import { PopupIconButtonReusable } from "../allPopupReusableIconButton/PopupIconButtonReusable";
import InputNumberFunc from "../../../../function/InputNumberFunc";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import {
  vendor_accept_pending_diner,
  get_diner_reservation,
} from "../../../../store/actions/dashboardAction/addingAction";
import { edit_order_vendor_side } from "../../../../store/actions/OrderingAction/vendorOrderingAction";
import { rsvp_added_waittime_event_request } from "../../../../store/actions/RsvpEventDashboard/RsvpEventDashboardAction";
import isEmpty from "../../../../store/validation/is-Empty";
import { ReusableOnboardingButton } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { sa_vd_reset_diner_request } from "../../../../store/actions/SuperAdminVendorDashboardAction/SuperAdminSeatingAction";
import NewCountDown from "./NewCountDown";

export class EditWaitTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      enter_wait_time: "00",
      select_wait_time: "00",
      diner_id: "",
      errors: {},
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (!isEmpty(nextProps.allDataProps) !== nextState.diner_id) {
      return {
        diner_id: nextProps.allDataProps,
        open: nextProps?.editWaitTimeModel || nextState.open,
      };
    }
  }

  onOpenModal = (e) => {
    if (this.props.orderData === 7 || this.props.orderData === 8) {
      Alert.error(
        `<h4>You can't perform this action because your order is ${
          this.props.orderData === 7
            ? "Completed"
            : this.props.orderData === 8
            ? "Cancelled"
            : ""
        }</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        }
      );
    } else {
      this.setState({ open: true });
    }
  };

  onCloseModal = (e) => {
    this.setState({ open: false });
    if (this.props?.noDisplay && this.props?.changeEditWaitTimeModel) {
      this.props.changeEditWaitTimeModel();
    }
  };

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  onChange = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    this.setState({
      [e.target.name]: number,
      errors: {},
    });
    this.props.clear_all_errors();
  };

  /***************************
   * @DESC Big Button Handler
   ***************************/
  bigButtonHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      enter_wait_time: type,
    });
  };

  /******************************
   * @DESC - ON PENDING SUBMIT HANDLER
   *****************************/
  onPendingSubmitHandler = (e) => {
    e.preventDefault();
    const token = this.props.auth.user.accessToken;
    const diner_id = this.state.diner_id;
    const vendor_id =
      this.props.actionBy === "ADMIN"
        ? this.props.adminSendVendorId
        : this.props.auth.user.VendorUser._id;
    if (
      this.state.enter_wait_time === "" &&
      this.state.select_wait_time === ""
    ) {
      Alert.error(`<h4>Please Select Or Enter Wait Time</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      const formData = {
        wait_time: parseInt(this.state.enter_wait_time),
        diner_status: "NOTSEATED",
      };
      if (this.props.actionBy === "ADMIN") {
        this.props.sa_vd_reset_diner_request(
          formData,
          diner_id,
          vendor_id,
          token,
          this.successCallback
        );
      } else {
        this.props.vendor_accept_pending_diner(
          formData,
          diner_id,
          vendor_id,
          token,
          this.successCallback
        );
      }
    }
  };

  successCallback = (e) => {
    Alert.success(`<h4>Wait Time Add Successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    this?.props?.noDisplay && this?.props?.changeEditWaitTimeModel
      ? this.props.changeEditWaitTimeModel()
      : this.onCloseModal();
    // this.onCloseModal();
    this.props.closedMainModal();
  };

  /******************************
   * @DESC - ON SEATING SUBMIT HANDLER
   *****************************/
  onSeatingSubmitHandler = (e) => {
    e.preventDefault();
    const token = this.props.auth?.user?.accessToken;
    const diner_id = this.state.diner_id;
    const vendor_id =
      this.props.actionBy === "ADMIN"
        ? this.props.adminSendVendorId
        : this.props?.auth?.user?.VendorUser?._id;
    if (this.state.enter_wait_time === "") {
      Alert.error(`<h4>Please Select Or Enter Wait Time</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      if (this.props.actionBy === "order") {
        const formData = {
          max_time: parseInt(this.state.enter_wait_time),
          id: this.props.orderId,
          max_time_date: Date.now(),
        };
        this.props.edit_order_vendor_side(
          token,
          formData,
          this.onSuccessCallback
        );
      } else if (this.props.actionBy === "RsvpEvent") {
        const formData = {
          vendor_id: this.props.auth.user.VendorUser._id,
          event_id: this.props.status.event_id,
        };
        const waitTimeData = {
          wait_time: parseInt(this.state.enter_wait_time),
          // event_status: this.props.status.event_status,
        };
        this.props.rsvp_added_waittime_event_request(
          formData,
          waitTimeData,
          diner_id,
          token,
          this.onSuccessCallback
        );
      } else {
        const formData = {
          wait_time: parseInt(this.state.enter_wait_time),
          wait_time_date: Date.now(),
        };
        if (this.props.actionBy === "ADMIN") {
          this.props.sa_vd_reset_diner_request(
            formData,
            diner_id,
            vendor_id,
            token,
            this.onSuccessCallback
          );
        } else {
          this.props.vendor_accept_pending_diner(
            formData,
            diner_id,
            vendor_id,
            token,
            this.onSuccessCallback
          );
        }
      }
    }
    // this.props.get_diner_reservation(vendor_id);
  };

  onSuccessCallback = (e) => {
    if (this.props.actionBy === "order") {
      this.props.getUpdatedData();
    } else {
      Alert.success(`<h4>Wait Time Add Successfully</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
    // this?.props?.noDisplay
    //   ? this.props.changeEditWaitTimeModel()
    //   : this.onCloseModal();
    this.onCloseModal();
  };

  render() {
    const { open, enter_wait_time } = this.state;
    return (
      <div>
        {this.props.noDisplay ? (
          <div onClick={this.onOpenModal}>{this.props.noDisplay}</div>
        ) : (
          <>
            {this.props.editButtonStatus === "pendingEdit" ? (
              <PopupActionButton
                buttonText={this.props.buttonText}
                buttonType="button"
                // buttonClass="yesButton"
                buttonClass="smallsave"
                onClick={this.onOpenModal}
                buttonImage={this.props.IconButton}
              />
            ) : this.props.editButtonStatus === "viewButtonEdit" ? (
              <div className="f14-500 text-red mb-1" onClick={this.onOpenModal}>
                <NewCountDown waitNew={this.props?.waitTimeDiff} />
              </div>
            ) : (
              <PopupIconButtonReusable
                buttonClass="editButton"
                buttonType="button"
                titleText="Edit Timer"

                image={require("../../../../assets/images/superadmin/ordericon/Edit.svg")}
                onClick={this.onOpenModal}
              />
            )}
          </>
        )}

        {/* <Modal
          open={open}
          onClose={this.onCloseModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "small-popup",
            closeButton: "customCloseButton",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        >
          <div className="text-left reusable-popup-header-newstyle">
            <h4>
              {this.props.editButtonStatus === "pendingEdit"
                ? "Enter Wait Time"
                : "Edit Wait Time"}
            </h4>
          </div> */}
        <Modal
          show={open}
          onHide={this.onCloseModal}
          centered
          size="md"
          style={{ zIndex: "1061" }}
        >
          <Modal.Header className="border-0 px-md-4" closeButton>
            <Modal.Title className="f24-700">
              {this.props.editButtonStatus === "pendingEdit"
                ? "Enter Wait Time"
                : "Edit Wait Time"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-md-4">
            <div className="reason-for-cancellation p-0">
              <Form
                noValidate
                onSubmit={
                  this.props.editButtonStatus === "pendingEdit"
                    ? this.onPendingSubmitHandler
                    : this.onSeatingSubmitHandler
                }
              >
                <div className="mt-2 mb-3">
                  <div className="d-flex justify-content-between align-items-baseline mb-4">
                    <div className="w-75">
                      <div className="d-flex align-items-center">
                        <NewInputText
                          extraClass="mt-4 mb-0"
                          name="enter_wait_time"
                          inputType="number"
                          onChange={this.onChange}
                          onKeyDown={InputNumberFunc}
                          maxLength="10"
                          // onChange={this.onChange}
                          value={this.state.enter_wait_time}
                          labelText="Enter Wait Time"
                          controlClass={"outlined-helperText "}
                        />
                        <p className="minu-section ml-2 mb-0">Mins</p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="font_20_m">
                    Select one relevant option from below
                  </div>
                  <div className="font_16_r mt-2 mb-4">
                    Highest value from below will be sent as wait time
                  </div>
                  <div className="d-flex flex-wrap justify-content-between">
                    <PopupInsideButton
                      buttonClass={
                        enter_wait_time === "00"
                          ? "status-selected-button-box font_20_m sts_sld_btn_box_a mb-4"
                          : "status-selected-button-box font_20_m mb-4"
                      }
                      buttonText="00 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "00")}
                    />
                    <PopupInsideButton
                      buttonClass={
                        enter_wait_time === "05"
                          ? "status-selected-button-box font_20_m sts_sld_btn_box_a mb-4"
                          : "status-selected-button-box font_20_m mb-4"
                      }
                      buttonText="05 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "05")}
                    />
                    <PopupInsideButton
                      buttonClass={
                        enter_wait_time === "10"
                          ? "status-selected-button-box font_20_m sts_sld_btn_box_a mb-4"
                          : "status-selected-button-box font_20_m mb-4"
                      }
                      buttonText="10 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "10")}
                    />
                    <PopupInsideButton
                      buttonClass={
                        enter_wait_time === "15"
                          ? "status-selected-button-box font_20_m sts_sld_btn_box_a mb-4"
                          : "status-selected-button-box font_20_m mb-4"
                      }
                      buttonText="15 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "15")}
                    />
                    <PopupInsideButton
                      buttonClass={
                        enter_wait_time === "20"
                          ? "status-selected-button-box font_20_m sts_sld_btn_box_a mb-4"
                          : "status-selected-button-box font_20_m mb-4"
                      }
                      buttonText="20 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "20")}
                    />
                    <PopupInsideButton
                      buttonClass={
                        enter_wait_time === "25"
                          ? "status-selected-button-box font_20_m sts_sld_btn_box_a mb-4"
                          : "status-selected-button-box font_20_m mb-4"
                      }
                      buttonText="25 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "25")}
                    />
                    <PopupInsideButton
                      buttonClass={
                        enter_wait_time === "30"
                          ? "status-selected-button-box font_20_m sts_sld_btn_box_a mb-4"
                          : "status-selected-button-box font_20_m mb-4"
                      }
                      buttonText="30 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "30")}
                    />
                  </div>
                </div>
                <div className="mt-3 d-flex">
                  <ReusableOnboardingButton
                    buttonTitle="Cancel Button"
                    buttonClass={
                      "onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                    }
                    buttonText="Cancel"
                    onClick={this.onCloseModal}
                    buttonType="button"
                  />
                  <ReusableOnboardingButton
                    buttonTitle="Save Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                    buttonText="Save"
                    onClick={
                      this.props.editButtonStatus === "pendingEdit"
                        ? this.onPendingSubmitHandler
                        : this.onSeatingSubmitHandler
                    }
                    buttonType="button"
                  />
                </div>
              </Form>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

EditWaitTime.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  sa_vd_reset_diner_request,

  vendor_accept_pending_diner,
  get_diner_reservation,
  edit_order_vendor_side,
  rsvp_added_waittime_event_request,
})(withRouter(EditWaitTime));
